import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserPerfilComponent } from 'src/app/modules/user/user-perfil/user-perfil.component';
import { Gtp } from '../../gtp';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { Router } from '@angular/router';
import { Constant, VersionChange } from '../../../shared/constant';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.component.scss']
})
export class HeaderTopComponent implements OnInit {

  userLoged: string = '';
  userPlan: number = 1;
  planName: string = '';
  planGradient: string = '';

  @Output() closeSidebar = new EventEmitter<Event>();

  constructor(
    private gtp: Gtp,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router,
    private constant: Constant
  ) {
    this.userInfo();
  }

  ngOnInit(): void {
  }

  // Getters para acceder a la información de versión desde constant.ts
  get appVersion(): string {
    return this.constant.version;
  }

  get appVersionDate(): string {
    return this.constant.fechaUltAct;
  }

  userInfo(){
    let tmp = JSON.parse(this.gtp.getItemLocalStorage('currentUser'));
    if(tmp['username']){
      this.userLoged = tmp['username'];
    }

    // Obtener plan del usuario
    let user = JSON.parse(this.gtp.getUserData());
    this.userPlan = user.cliente_plan_id || 1;
    this.setPlanStyles();
  }

  setPlanStyles(){
    switch (this.userPlan) {
      case 1: // PRO
        this.planName = 'Plan PRO';
        this.planGradient = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
        break;
      case 2: // PLUS
        this.planName = 'Plan PLUS';
        this.planGradient = 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)';
        break;
      case 3: // LITE
        this.planName = 'Plan LITE';
        this.planGradient = 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)';
        break;
      case 4: // TANQUE
        this.planName = 'Plan TANQUE';
        this.planGradient = 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)';
        break;
      default:
        this.planName = 'Plan BÁSICO';
        this.planGradient = 'linear-gradient(135deg, #78909C 0%, #546E7A 100%)';
        break;
    }
  }

  miCuenta(){
    this.dialog.open(UserPerfilComponent, {
      width: '650px',
      panelClass: 'popMiCuenta'
    });
  }

  logOut(){
    //location.reload();
    this.authenticationService.logout();
  }

  closeSideNav(event: Event): void {
    this.closeSidebar.emit(event);
  }
}
